import Vue from 'vue';
import Router from 'vue-router';
import siteRoutes from './site/routes';
import getSkinEngineRoutes from './projects/skinengine/routes';

const config = require('../config.json');

Vue.use(Router);

const routes = [
  getSkinEngineRoutes(config),
  siteRoutes,
];

export default new Router({
  mode: 'history',
  base: config.base,
  routes,
});
